module.exports = __webpack_public_path__ + "static/media/ic_seats_reserved.bcd2660a.png";